module.exports = __webpack_public_path__ + "static/media/bonarka01.fb34515a.jpg";